import SubscribeEventsToggle from './_subscribe-events-toggle.js'
import FlexPane from './_flex-pane.js'
import Button from './_button.js'
import Image from './_image.js'
import Popup from './_popup.js'
import DotNotification from './_dot-notification.js'

export default {
  name: 'EventNotificationSubscriber',
  values: {
    subscribeEventsToggle: {
      configSet: SubscribeEventsToggle,
      configValues: {
        container: {
          style: {
            flexGrow: 1,
            alignItems: 'center',
            justifyContent: 'space-between',
            padding: '0 8px',
            minHeight: '56px',
          },
        },
      },
    },
    container: {
      configSet: FlexPane,
      configValues: {
        createStackingContext: true,
        style: {
          flexGrow: 0,
          minWidth: '32px',
          height: '32px',
          _desktop_padding: '0 0 0 4px',
          _mobile_minWidth: '40px',
          _mobile_height: '40px',
        },
      },
    },
    subscribeNotificationButton: {
      configSet: Button,
      configValues: {
        style: {
          base: {
            justifyContent: 'center',
            alignItems: 'center',
          },
        },
      },
    },
    bellIcon: {
      configSet: Image,
      configValues: {
        src: 'bell',
        style: {
          minWidth: '16px',
          minHeight: '16px',
        },
      },
    },
    notificationPopup: {
      configSet: Popup,
      configValues: {
        isOverlayMode: false,
        content: {
          style: {
            base: {
              padding: 0,
            },
          },
        },
        container: {
          fixed: false,
          style: {
            width: '344px',
            _mobile_width: '328px',
            top: '42px',
            right: '4px',
          },
        },
        arrowhead: {
          direction: 'up',
        },
        arrowheadOffset: '-6px',
        _mobile_arrowheadOffset: '-10px',
      },
    },
    dotNotification: {
      configSet: DotNotification,
      configValues: {
        style: {
          rootContainer: {
            top: '-10px',
            right: '-2px',
          },
          dot: {
            width: '8px',
            height: '8px',
          },
        },
      },
    },
  },
  meta: {
    extendable: false,
  },
}
